/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { ApiService } from '../../../commons/services/api/api.service'
import { IUserHierarchyConfig } from './models/user-Hierarchy.model'
import { IMerchants, IProgramGroup, IEnterprise, IUserHierarchy } from '../user-list/models/hierarchy.model'
import { CacheService } from '../../../../src/commons/services/business/cache.service'
import { UserClaims } from '../../../../src/commons/enums/user-claims.enum'
import { CloneUserModel } from '../invite-user/models/clone-user'
import { LoadingController } from '@ionic/angular/standalone'
import { HierarchyBase } from '../services/hierarchy-base'
import { UserApiService } from '../../../../src/security/models/services/users/userApi.service'
import { AuthWrapperService } from '../../../../src/security/models/services/auth'

@Component({
  selector: 'app-hierarchy',
  templateUrl: 'user-hierarchy.component.html',
  styleUrls: ['user-hierarchy.component.scss'],
})
export class UserHierarchyComponent extends HierarchyBase implements OnInit {

  @Input() userId: number
  @Input() readonly = true

  @Input() cloneUser: CloneUserModel

  @Input() selectedUserHierarchy: IUserHierarchyConfig
  @Output() selectedUserHierarchyChange: EventEmitter<IUserHierarchyConfig> = new EventEmitter<IUserHierarchyConfig>()

  userHierarchy: IUserHierarchy = {
    listEnterprise: [],
    isAssignedFullHierarchy: false
  }

  public error = null
  private loading

  constructor(
    private readonly translate: TranslateService,
    public userApiService: UserApiService,
    private apiService: ApiService,
    private cacheService: CacheService,
    private authWrapper: AuthWrapperService,
    private loadingController: LoadingController
  ) {
    super()
  }

  async ngOnInit(): Promise<void> {
    try {
      void this.presentLoading()
      if (this.userId) {
        const userInfo = await this.cacheService.getUserInfo()

        if (this.userId === userInfo?.rId) {
          //An Admin user may NOT edit their own hierarchy
          this.readonly = true
        }

        this.userHierarchy = await this.apiService.getUserHierarchy(this.userId)

        this.selectedUserHierarchy = {
          isAssignedFullHierarchy: this.userHierarchy.isAssignedFullHierarchy,
          sponsorBankRIds: [],
          enterpriseRIds: [].concat(... new Set(this.userHierarchy?.listEnterprise.filter(e => e.isSelected).map(m => m.rId))),
          merchantRIds: [].concat(... new Set(this.userHierarchy?.listEnterprise.map(e => e.merchants.filter(m => m.isSelected).map(m => m.rId)))),
          programGroupRIds: [].concat(... new Set(this.userHierarchy?.listEnterprise.map(e => e.programGroups.filter(pg => pg.isSelected).map(pg => pg.rId))))
        }

        if (!this.readonly && !this.authWrapper.isInternalUser()) {
          const userPermissions = await this.userApiService.getUserPermissions(this.userId)
          //An Admin user may NOT edit the hierarchy of another admin user. (Admin user is anyone who has the "edit user" or "create new user" claim permissions).
          this.readonly =
            userPermissions.claims.filter((c) => c.key === UserClaims.EditUser || c.key === UserClaims.InviteNewUser)
              .length > 0
        }
      }
      else if (this.cloneUser != null) {
        this.userHierarchy = await this.apiService.getUserHierarchy(this.cloneUser.userId)

        this.selectedUserHierarchy = {
          isAssignedFullHierarchy: this.userHierarchy.isAssignedFullHierarchy,
          sponsorBankRIds: [],
          enterpriseRIds: [].concat(... new Set(this.userHierarchy?.listEnterprise.filter(e => e.isSelected).map(m => m.rId))),
          merchantRIds: [].concat(... new Set(this.userHierarchy?.listEnterprise.map(e => e.merchants.filter(m => m.isSelected).map(m => m.rId)))),
          programGroupRIds: [].concat(... new Set(this.userHierarchy?.listEnterprise.map(e => e.programGroups.filter(pg => pg.isSelected).map(pg => pg.rId))))
        }
      }
      else {
        this.userHierarchy = await this.apiService.getCurrentOrgHierarchy()
      }

      //setting values based on the user selection
      if (this.selectedUserHierarchy?.enterpriseRIds.length) {
        this.userHierarchy.isAssignedFullHierarchy = this.selectedUserHierarchy.isAssignedFullHierarchy

        this.userHierarchy.listEnterprise.forEach(e => {
          e.isSelected = this.selectedUserHierarchy.enterpriseRIds.indexOf(e.rId) >= 0

          e.merchants.forEach(m => {
            m.isSelected = this.selectedUserHierarchy.merchantRIds.indexOf(m.rId) >= 0
          })

          e.programGroups.forEach(p => {
            p.isSelected = this.selectedUserHierarchy.programGroupRIds.indexOf(p.rId) >= 0
          })
        })
      }

      this.userHierarchy.listEnterprise.forEach(() => this.segmentValues.push('programs'))
      this.processSelectedHierarchy()

    }
    catch (err) {
      this.error = err
    } finally {
      await this.dismissLoading()
    }
  }

  public get hasNoSelection(): boolean {
    return (this.selectedUserHierarchy?.merchantRIds.length === 0
      && this.selectedUserHierarchy?.programGroupRIds.length === 0) || false
  }

  public toggleAssignedFullHierarchy(event): void {
    this.userHierarchy.isAssignedFullHierarchy = event.detail.checked as boolean

    this.userHierarchy.listEnterprise.forEach(e => {
      e.isSelected = event.detail.checked

      e.merchants.forEach(m => m.isSelected = event.detail.checked)
      e.programGroups.forEach(p => p.isSelected = event.detail.checked)
    })

    this.processSelectedHierarchy()
  }

  public toggleEnterprise(enterprise: IEnterprise, event): void {
    if (enterprise.isSelected == event.detail.checked) {
      return
    }

    enterprise.isSelected = event.detail.checked
    enterprise.merchants.forEach(m => m.isSelected = event.detail.checked)
    enterprise.programGroups.forEach(p => p.isSelected = event.detail.checked)

    this.processSelectedHierarchy()
  }

  public toggleMerchants(enterprise: IEnterprise, merchant: IMerchants, event): void {
    merchant.isSelected = event.detail.checked

    this.checkEnterprise(enterprise)
  }

  public togglePrograms(enterprise: IEnterprise, program: IProgramGroup, event): void {
    program.isSelected = event.detail.checked

    this.checkEnterprise(enterprise)
  }

  private checkEnterprise(enterprise: IEnterprise) {
    const selectedMerchants = enterprise.merchants.filter(m => m.isSelected)
    const selectedPrograms = enterprise.programGroups.filter(p => p.isSelected)

    enterprise.isSelected = selectedMerchants.length !== 0 || selectedPrograms.length !== 0

    this.processSelectedHierarchy()
  }

  private processSelectedHierarchy(): void {
    const enterpriseRIds: number[] = []
    let merchantRIds: number[] = []
    let programGroupRIds: number[] = []

    this.userHierarchy.listEnterprise.forEach(e => {
      if (e.isSelected) {
        enterpriseRIds.push(e.rId)
      }

      merchantRIds = merchantRIds.concat(e.merchants?.filter(m => m.isSelected).map(m => m.rId))
      programGroupRIds = programGroupRIds.concat(e.programGroups?.filter(p => p.isSelected).map(p => p.rId))
    })

    if (this.selectedUserHierarchy) {
      this.selectedUserHierarchy.enterpriseRIds = [...new Set(enterpriseRIds)]
      this.selectedUserHierarchy.merchantRIds = [...new Set(merchantRIds)]
      this.selectedUserHierarchy.programGroupRIds = [...new Set(programGroupRIds)]
      this.selectedUserHierarchy.isAssignedFullHierarchy = this.userHierarchy.isAssignedFullHierarchy
      this.selectedUserHierarchyChange.emit(this.selectedUserHierarchy)
    }
  }

  private async presentLoading() {
    this.loading = await this.loadingController.create({
      message: this.translate.instant('administration.loading'),
    })
    await this.loading.present()
  }

  private async dismissLoading() {
    await this.loading.dismiss()
  }
}
